export enum APIErrorTypes {
  AuthTransactionExpired = "id.justworks.com/errors/AuthTransactionExpiredError",
  FormValidationError = "id.justworks.com/errors/auth/register/FormValidationError",
  OktaServerError = "id.justworks.com/errors/auth/OktaServerError",
}

export enum FieldErrorType {
  FirstNameValidationError = "id.justworks.com/errors/auth/register/FormValidationError/FirstName",
  LastNameValidationError = "id.justworks.com/errors/auth/register/FormValidationError/LastName",
  UsernameValidationError = "id.justworks.com/errors/auth/register/FormValidationError/Username",
  UsernameTakenError = "id.justworks.com/errors/auth/register/FormValidationError/UsernameTaken",
  EmailValidationError = "id.justworks.com/errors/auth/register/FormValidationError/Email",
  PasswordValidationError = "id.justworks.com/errors/auth/register/FormValidationError/Password",
  CommonPasswordValidationError = "id.justworks.com/errors/auth/register/FormValidationError/CommonPassword",
}

export type InvalidFieldType = {
  fieldId: string;
  type: FieldErrorType;
  detail: string;
};

export type ProblemDetailsError<T extends APIErrorTypes> = {
  type: T;
  title: string;
  status: number;
  detail: string;
  instance: string;
};

export type InvalidFieldDetailsError<T extends APIErrorTypes> =
  ProblemDetailsError<T> & {
    invalidFields?: InvalidFieldType[];
  };
